var shopifyAsset = window.shopifyAsset || function(p){ return p; };
/* ============================================================
   DAULATRAM'S — Shopify Theme JavaScript
   Common UI behaviours: header scroll, scroll-reveal,
   carousels, marquee, testimonials, counter animations,
   social proof toasts, newsletter, video modals.
   ============================================================ */

(function () {
  'use strict';

  /* ---- Header scroll behaviour ---- */
  (function () {
    var header = document.querySelector('.header');
    if (!header) return;
    function onScroll() {
      var scrolled = window.scrollY > 40;
      header.classList.toggle('scrolled', scrolled);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(function () { header.classList.add('revealed'); }, 100);
    onScroll();
  })();

  /* ---- Home header inside the banner (desktop): see styles.css ---- */
  (function () {
    var body = document.body;
    var header = document.querySelector('.header');
    if (!header || !body.classList.contains('home-floating-header')) return;
    var wide = window.matchMedia('(min-width: 981px)');
    var lastY = window.scrollY;
    function update() {
      var y = Math.max(0, window.scrollY);
      if (!wide.matches) {
        header.style.removeProperty('--hf-top');
        body.classList.remove('hf-solid', 'hf-hidden');
        lastY = y;
        return;
      }
      header.style.setProperty('--hf-top', Math.max(0, 40 - y) + 'px');
      body.classList.toggle('hf-solid', y > 10);
      if (y < 120) {
        body.classList.remove('hf-hidden');
        lastY = y;
      } else if (Math.abs(y - lastY) > 4) {
        if (!header.matches(':focus-within')) body.classList.toggle('hf-hidden', y > lastY);
        lastY = y;
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  })();

  /* ---- Scroll Reveal (IntersectionObserver) ---- */
  (function () {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.sr,.sr-stagger').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '300px 0px', threshold: 0.01 });

    document.querySelectorAll('.sr,.sr-stagger').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight + 300) {
        el.classList.add('in');
      } else {
        io.observe(el);
      }
    });
  })();

  /* ---- Counter animation ---- */
  (function () {
    var els = document.querySelectorAll('[data-count]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var target = parseInt(el.getAttribute('data-count'), 10);
        var suffix = el.getAttribute('data-suffix') || '';
        var start = 0;
        var duration = 1800;
        var step = function (ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          el.textContent = Math.floor(progress * target).toLocaleString('en-IN') + suffix;
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toLocaleString('en-IN') + suffix;
        };
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ---- Horizontal carousels (home bestsellers etc.) ---- */
  (function () {
    document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('.carousel');
      var prevBtn = wrap.querySelector('.car-btn.prev');
      var nextBtn = wrap.querySelector('.car-btn.next');
      if (!track) return;
      function scroll(dir) {
        var card = track.querySelector('.product-card');
        var step = card ? (card.getBoundingClientRect().width + 24) : 280;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { scroll(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scroll(1); });
    });
  })();

  /* ---- Marquee content: section handles rendering; theme.js only provides fallback if empty ---- */
  (function () {
    var track = document.getElementById('marquee-track');
    if (!track || track.children.length > 0) return; // section already populated it
    var items = [
      '🌿 100% Natural Ingredients',
      '✓ FSSAI Approved',
      '🚚 Free Shipping ₹1000+',
      '⭐ 4.7/5 · 17,719+ Reviews',
      '💊 Vegetarian Capsules',
      '🇮🇳 Made in Karnal, Haryana',
      '🔒 Secure Payment',
      '↩️ Easy Returns'
    ];
    var doubled = items.concat(items);
    track.innerHTML = doubled.map(function (t) {
      return '<span class="m-item">' + t + '</span>';
    }).join('');
  })();

  /* ---- Media logos (home) ---- */
  (function () {
    var track = document.getElementById('logos-track');
    if (!track) return;
    var logos = [
      { name: 'Times of India', icon: '📰' },
      { name: 'NDTV', icon: '📺' },
      { name: 'Hindustan Times', icon: '📰' },
      { name: 'Economic Times', icon: '📊' },
      { name: 'India Today', icon: '🗞️' },
      { name: 'Business Standard', icon: '📈' }
    ];
    var doubled = logos.concat(logos);
    track.innerHTML = doubled.map(function (l) {
      return '<div class="logo-chip"><span>' + l.icon + '</span>' + l.name + '</div>';
    }).join('');
  })();

  /* ---- Hero Carousel ---- */
  (function () {
    var slides = document.querySelectorAll('.hero-slide');
    var dots = document.querySelectorAll('.hero-dot');
    var prevBtn = document.querySelector('.hero-nav-btn.prev');
    var nextBtn = document.querySelector('.hero-nav-btn.next');
    if (!slides.length) return;
    var current = 0;
    var total = slides.length;
    function goTo(idx) {
      slides[current].classList.remove('active');
      dots[current] && dots[current].classList.remove('active');
      current = (idx + total) % total;
      slides[current].classList.add('active');
      dots[current] && dots[current].classList.add('active');
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });
    var auto = setInterval(function () { goTo(current + 1); }, 4500);
    var carousel = document.querySelector('.hero-carousel');
    if (carousel) {
      carousel.addEventListener('mouseenter', function () { clearInterval(auto); });
      carousel.addEventListener('mouseleave', function () { auto = setInterval(function () { goTo(current + 1); }, 4500); });
    }
  })();

  /* Testimonials carousel is owned by site.js (seamless infinite loop + dots).
     This duplicate engine was removed — it used to run a second, conflicting
     setInterval on the same track, fighting site.js for control of transform. */

  /* ---- Category grid (home page) ---- */
  (function () {
    var grid = document.getElementById('cat-grid');
    // Skip JS rendering if Liquid section already populated the grid
    if (!grid || grid.children.length > 0) return;
    var cats = [
      { name: "Men's Wellness", img: shopifyAsset('categories-cat_item9.jpg'), url: '/collections/mens-wellness' },
      { name: "Women's Wellness", img: shopifyAsset('categories-cat_item10.jpg'), url: '/collections/womens-wellness' },
      { name: 'Hair Care', img: shopifyAsset('categories-cat_item2.jpg'), url: '/collections/hair-care' },
      { name: 'Skin Care', img: shopifyAsset('categories-cat_item7.jpg'), url: '/collections/skin-care' },
      { name: 'Desi Ghee', img: shopifyAsset('categories-cat_item4.jpg'), url: '/collections/desi-ghee' },
      { name: 'Honey', img: shopifyAsset('categories-cat_item1.jpg'), url: '/collections/honey' },
      { name: 'Cold Pressed Oils', img: shopifyAsset('categories-cat_item3.jpg'), url: '/collections/cold-pressed-oils' },
      { name: 'Wellness', img: shopifyAsset('categories-cat_item8.jpg'), url: '/collections/wellness' },
      { name: 'Weight Loss', img: shopifyAsset('categories-cat_item6.jpg'), url: '/collections/weight-loss' },
      { name: 'Kitchen & Home', img: shopifyAsset('categories-kitchen-home.jpg'), url: '/collections/kitchen-home' }
    ];
    grid.className = 'cat-grid sr-stagger';
    grid.innerHTML = cats.map(function (c) {
      return '<a class="cat-card cat-card-photo" href="' + c.url + '">' +
        '<div class="cat-photo-wrap"><img class="cat-photo" src="' + c.img + '" alt="' + c.name + '" loading="lazy"></div>' +
        '<div class="cat-name">' + c.name + '</div>' +
        '<div class="cat-arrow">→</div>' +
      '</a>';
    }).join('');
  })();

  /* ---- Newsletter forms ---- */
  (function () {
    document.querySelectorAll('[data-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var successMsg = form.getAttribute('data-success') || '🎉 Thank you for subscribing!';
        form.innerHTML = '<div class="success-msg">' + successMsg + '</div>';
      });
    });
  })();

  /* ---- FAQ accordion ---- */
  (function () {
    document.addEventListener('click', function (e) {
      var q = e.target.closest('.faq-q, .pdp-faq-q');
      if (!q) return;

      var item = q.closest('.faq-item, .pdp-faq-item');
      var ans = q.nextElementSibling || (item ? item.querySelector('.faq-a, .pdp-faq-a') : null);
      if (!ans) return;

      var wasOpen = q.classList.contains('open') || (item && item.classList.contains('open')) || ans.classList.contains('open') || (ans.style.maxHeight && ans.style.maxHeight !== '0px');

      // Close all open FAQs
      document.querySelectorAll('.faq-q, .pdp-faq-q').forEach(function (btn) {
        btn.classList.remove('open');
        var parentItem = btn.closest('.faq-item, .pdp-faq-item');
        if (parentItem) parentItem.classList.remove('open');
        var a = btn.nextElementSibling || (parentItem ? parentItem.querySelector('.faq-a, .pdp-faq-a') : null);
        if (a) {
          a.classList.remove('open');
          a.style.maxHeight = '0px';
        }
      });

      // If it wasn't open before, open this item
      if (!wasOpen) {
        q.classList.add('open');
        if (item) item.classList.add('open');
        ans.classList.add('open');
        ans.style.maxHeight = (ans.scrollHeight + 40) + 'px';
      }
    });
  })();

})();


/* ---- Shopify Cart Integration ---- */
window.addToCartShopify = function(variantId, title, price, imgSrc) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    // Update cart count badge
    return fetch('/cart.js');
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var badges = document.querySelectorAll('.cart-badge-count');
    badges.forEach(function(b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? '' : 'none';
    });
    // Show mini toast
    var t = document.createElement('div');
    t.className = 'sp-toast show';
    t.style.cssText = 'position:fixed;bottom:80px;left:20px;z-index:9999;background:#fff;border-radius:12px;padding:14px 18px;box-shadow:0 4px 20px rgba(0,0,0,0.15);display:flex;align-items:center;gap:12px;max-width:280px;';
    t.innerHTML = (imgSrc ? '<img src="'+imgSrc+'" style="width:48px;height:48px;border-radius:8px;object-fit:cover;">' : '<span style="font-size:24px;">🛒</span>') +
      '<div><div style="font-weight:600;font-size:13px;color:#1a1a1a;">' + title + '</div><div style="font-size:12px;color:#666;">Added to cart</div></div>';
    document.body.appendChild(t);
    setTimeout(function() { if(t.parentNode) t.parentNode.removeChild(t); }, 2500);
  })
  .catch(function(err) { console.error('Cart error:', err); });
};

/* ---- Mobile drawer toggle ---- */
(function() {
  var burger = document.getElementById('burger');
  var drawer = document.getElementById('mobile-drawer');
  var overlay = document.getElementById('drawer-overlay');
  if (!burger || !drawer) return;
  function openDrawer() { drawer.classList.add('open'); if(overlay) overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer.classList.remove('open'); if(overlay) overlay.classList.remove('open'); document.body.style.overflow = ''; }
  burger.addEventListener('click', openDrawer);
  if(overlay) overlay.addEventListener('click', closeDrawer);
  var closeBtn = document.getElementById('drawer-close');
  if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
})();




